import './styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppRoot } from './app/AppRoot';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element');
createRoot(container).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>,
);
